$(function(){

  /*-------------------------------------
   * サイトの共通設定
   *------------------------------------*/
  var init = function() {

    var $original_stickey_header = $("sticky-header")
//    var $original_announce_bar = $(".announcement-bar:not(#headerAreaOuter)").clone();

    //$(".announcement-bar:not(#headerAreaOuter)").parents(".shopify-section:first").addClass("headerAreaSection");

    //告知バーに閉じるボタンを追加
    //$(".announcement-bar:not(#headerAreaOuter)").addClass("headerBtn");
    //$(".announcement-bar:not(#headerAreaOuter) > div").addClass("box");
    //$(".announcement-bar:not(#headerAreaOuter)").each(function(){
    //  $('<span class="btn">×</span>').prependTo($(this).find(".box:first")).on("click", function() {
    //    $(this).parents(".announcement-bar:first").remove();
    //  });
    //});
    $(".announcement-bar_close").on("click", function() {
      $(this).parents(".announcement-bar:first").remove();
    });
/*
    $(".announcement-bar:last").after(`
      <div id="headerAreaOuter" class="announcement-bar gradient" role="region" aria-label="ヘッダー">
        <div class="page-width">
          <div id="headerArea">
            <p id="HdLogo"><a id="hlogo_anc" href="/" title="アフターブーケ® 公式サイト | カナックス">アフターブーケ® 公式サイト | カナックス</a></p>
          </div>
          <div class="headerContactBtnArea">
            <ul>
              <li><a href="/concierge/" title="コンシェルジュに相談" class="concierge"><span>コンシェルジュに相談</span></a></li>
              <li><a href="/reserve-tokyo/" title="お花持ち込み予約" class="reserve"><span>お花持ち込み予約</span></a></li>
              <li><a href="/inquiry-form/" title="お問い合わせ" class="inquiry"><span>お問い合わせ</span></a></li>
            </ul>
            <div class="gnaviCart">
              <a class="transparentImg" href="/cart/" title="カート"></a>
              <div>
                <a href="/cart/" title="カート">
                  <span>1</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    `);
*/
//    $("#headerAreaOuter").show();


    //ヘッダーを複製（不要な要素は削除）

    $header = $("sticky-header:first");
    var $header2 = $("sticky-header").clone();
$header2.find("header.lang-menu").remove();
    $header2.attr("id", "headerAreaSectionS");
    $header2.removeClass("original-stickey-header");
    $header2.find("header-drawer").remove();
    $header2.find("header").addClass("headerArea");
    //$('<p class="HdLogo"><a id="hlogo_anc" href="/" title="アフターブーケ® 公式サイト | カナックス">アフターブーケ® 公式サイト | カナックス</a></p>').prependTo($header2.find("header"));
    $header2.find(".header__heading-link").wrap('<p class="HdLogo"></p>');
    $header2.find(".header__icons").remove();
    $header2.find(".header__inline-menu").append('<div class="gnaviCart"></div>');
    if ($(".gnaviAccount:not('.spView')").length) {
      $header2.find(".header__inline-menu").append($(".gnaviAccount").clone());
    }
    $header2.find(".announcement-bar").remove();
    $header2.css("display", "none");
    

    $("sticky-header").after($header2);

    var announcement_height = 0;
    $(".announcement-bar").each(function() {
      announcement_height += $(this).outerHeight(true);
    });

//console.log("announcement_height=" + announcement_height);

    var sticky_header_offset_top_default = $("sticky-header:first").offset().top;
    $(window).on('scroll.skin', function(e) {
/*
      var isview = $(window).scrollTop() < $("#contentsAreaSection").offset().top;
      if(!isview && hs == 0) {
        hs = 1;
        $("#headerAreaSectionS").fadeIn(800);
      } else if (isview && hs == 1) {
        hs = 0;
        $("#headerAreaSectionS").fadeOut(400);
      }
*/

      if ($header2.css("display") == "none") {
//        console.log("offset:" + $header.offset().top + " scrollTop: " + $(window).scrollTop());
      } else {
//        console.log("offset:" + $header2.offset().top + " scrollTop: " + $(window).scrollTop());
      }
      var window_scroll_top = $(window).scrollTop();
      if (window_scroll_top >= announcement_height && ($header2.css("display") == "none" || $header.css("display") != "none")) {
        if (!$("body").hasClass("spLayout")) {
          //$header2.show();
          if ($("#headerAreaOuter #cart-icon-bubble.gnaviCart").length) {
          	$("#headerAreaSectionS .gnaviCart").html($("#headerAreaOuter #cart-icon-bubble.gnaviCart").html());
          	$("#headerAreaOuter #cart-icon-bubble.gnaviCart").removeAttr("id");
          	$("#headerAreaSectionS .gnaviCart").attr("id", "cart-icon-bubble");
          }

          $header2.fadeIn(800);
          $header.hide();
        }
      } else if (window_scroll_top < announcement_height && $header.css("display") == "none") {
        $header2.hide();
        //$header2.fadeOut(400);
        if ($("#headerAreaSectionS #cart-icon-bubble.gnaviCart").length) {
        	$("#headerAreaOuter .gnaviCart").html($("#headerAreaSectionS .gnaviCart").html());
        	$("#headerAreaSectionS .gnaviCart").removeAttr("id");
        	$("#headerAreaOuter .gnaviCart").attr("id", "cart-icon-bubble");
        }
        $header.show();
      }

    });


    $original_stickey_header.addClass("original-stickey-header");
    //$original_announce_bar.addClass("headerAreaLower").addClass("original-announcement-bar");
    //$original_announce_bar.hide();
    //$original_stickey_header.append($original_announce_bar);

    var setLayout = function() {
      //スマホ対応
      //if ($(window).width() <= 550) {
      //if ($(window).width() <= 989) {
      if ($(window).outerWidth() <= 989) {
        if (!$("body").hasClass("spLayout")) {
          $("body").addClass("spLayout");

          //カート情報
          if (!$(".gnaviCart.spView").attr("id")) {
          	$(".gnaviCart.spView").html($("#cart-icon-bubble.gnaviCart").html());
          	$("#cart-icon-bubble.gnaviCart").removeAttr("id");
          	$(".gnaviCart.spView").attr("id", "cart-icon-bubble");
          }
  if ($("body").hasClass("index")) {
//$original_announce_bar.show();
  }
        }
      } else {
        if ($("body").hasClass("spLayout")) {
          $("body").removeClass("spLayout");

          //カート情報
          if ($("#headerAreaSectionS").css("display") != "none") {
          	$("#headerAreaSectionS .gnaviCart").html($("#cart-icon-bubble.gnaviCart").html());
          	$("#cart-icon-bubble.gnaviCart").removeAttr("id");
          	$("#headerAreaSectionS .gnaviCart").attr("id", "cart-icon-bubble");
          } else {
          	$("#headerAreaOuter .gnaviCart").html($("#cart-icon-bubble.gnaviCart").html());
          	$("#cart-icon-bubble.gnaviCart").removeAttr("id");
          	$("#headerAreaOuter .gnaviCart").attr("id", "cart-icon-bubble");
          }
//$original_announce_bar.hide();
        }
      }
    }
    $(window).on("resize", function(){
      setLayout();
      if ($(window).outerWidth() >= 990) {
        if (announcement_height == 0) {
          $(".announcement-bar").each(function() {
            announcement_height += $(this).outerHeight(true);
          });
        }
      }
      $(window).trigger('scroll.skin');
    });
    setLayout();

    if ($("body").hasClass("spLayout")) {
  	  var urlHash = location.hash;
  	  if(urlHash){
        if (urlHash == '#delivery') {
          return;
        }
  	  } 
      var headerHeight = 54; //ヘッダーの高さ
      $(window).on("load", function(){
        var url = $(location).attr('href');
        if(url.indexOf("#") != -1){
          var anchor = url.split("#");
          //var target = $('#' + anchor[anchor.length - 1]);
          var target = $('#' + decodeURI(anchor[anchor.length - 1]));
          if(target.length){
            var pos = Math.floor(target.offset().top) - headerHeight; //ヘッダーの高さ
            $("html, body").animate({scrollTop:pos}, 500);
          }
        }
      });
      
      $('[href^="#"]').click(function(){
        var href= $(this).attr("href");
        if (!href.match(/^#modal/)) {
          var target = $(href == "#" || href == "" ? 'html' : href);
          if(target.length){
            var pos = target.offset().top - headerHeight; 
            $("html, body").animate({scrollTop:pos}, 500);
            return false;
          }
        }
      });
      
    } else {
      var headerHeight = 100; //ヘッダーの高さ
      $(window).on("load", function(){
        var url = $(location).attr('href');
        if(url.indexOf("#") != -1){
          var anchor = url.split("#");
          //var target = $('#' + anchor[anchor.length - 1]);
          var target = $('#' + decodeURI(anchor[anchor.length - 1]));
          if(target.length){
            var pos = Math.floor(target.offset().top) - headerHeight; //ヘッダーの高さ
            $("html, body").animate({scrollTop:pos}, 500);
          }
        }
      });
      $('[href^="#"]').click(function(){
        var href= $(this).attr("href");
        if (!href.match(/^#modal/)) {
          var target = $(href == "#" || href == "" ? 'html' : href);
          if(target.length){
            var pos = target.offset().top-headerHeight; 
            $("html, body").animate({scrollTop:pos}, 500);
            return false;
          }
        }
      });
    }


    //リンクの制御
    //お問合せとFAQは別タブで開く
    //$("a").each(function(){
    //var _href = $(this).attr("href");
    //if (typeof _href != "undefined" && (_href.match(/inquiry-form(\/)?$/) || _href.match(/faq(\/)?$/))) {
    //$(this).attr("target", "_blank");
    //}
    //});





    
    //PC表示時のグローバルメニューマウスオーバー制御
    var closeSubMenu = function() {
//return;
      $("nav.header__inline-menu .list-menu > li.open-sub-menu").each(function(){
        $(this).removeClass("open-sub-menu");
      });
    }
    $("nav.header__inline-menu .list-menu > li").hover(function(){
      if ($(this).hasClass("product-class-2")) {
        closeSubMenu();
        $(this).addClass("open-sub-menu");
      } else {
        closeSubMenu();
      }
    }, function(e){
      console.log("外れた");
      closeSubMenu();
    });
  }

  init();
/*
  if (typeof Shopify == "undefined") {
    Shopify = {};
  }
  Shopify.getUrlParam = function getParam(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }
*/
  var appendParam = function(url, param) {
    if (url.match(/#/)) {
      if (url.match(/\?/)) {
        return url.replace("#", "&" + param + "#");
      } else {
        return url.replace("#", "?" + param + "#");
      }
    } else if (url.match(/\?/)) {
      return url += "&" + param;
    } else {
      return url += "?" + param;
    }
  }
  var __nhdr = ($("html").hasClass("__nhdr") ? true : false);
  var __nftr = ($("html").hasClass("__nftr") ? true : false);
  var __ptn = ($("html").hasClass("__ptn") ? true : false);

  if (__nhdr || __nftr || __ptn) {
    setTimeout(function() {
      $('a:not([href^="#"])').each(function(){
        var href= $(this).attr("href");
        if (typeof href == "undefined") {
          return;
        }
        //同一hostの場合のみ調整する
        if (!href.match(/^\//) && !href.match(new RegExp(location.host.replace(".", "\\.")))) {
          return;
        }
        if (__nhdr) {
          href = appendParam(href, "__nhdr");
        }
        if (__nftr) {
          href = appendParam(href, "__nftr");
        }
        if (__ptn) {
          href = appendParam(href, "__ptn");
        }
        console.log("href:" + href);
        $(this).attr("href", href);
      });
    }, 2000);
  }
});

if (typeof Shopify == "undefined") {
  Shopify = {};
}
Shopify.getUrlParam = function getParam(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}
if (Shopify.getUrlParam("__nhdr") != null) {
  document.documentElement.classList.add("__nhdr");
}
if (Shopify.getUrlParam("__nftr") != null) {
  document.documentElement.classList.add("__nftr");
}
if (Shopify.getUrlParam("__ptn") != null) {
  document.documentElement.classList.add("__ptn");
}
//ドメイン書き換え（店舗ドメイン対応）
Shopify.rewriteLinkStr = function(str) {
  if (location.host == "dev.kannax.com" || location.host == "www.kannax.com" || location.host == "kannax.com") {
    //書き換え不要
    return str;
  }
  
  return str.replace(/\/\/dev\.kannax\.com/, '//' + location.host).replace(/\/\/www\.kannax\.com/, '//' + location.host).replace(/\/\/kannax\.com/, '//' + location.host);
}
Shopify.rewriteLink = function(content) {
  if (location.host == "dev.kannax.com" || location.host == "www.kannax.com" || location.host == "kannax.com") {
    //書き換え不要
    return content;
  } 
  var _replaceEl = function($a) {
    var href = $a.attr("href");
    if (href) {
      $a.attr("href", Shopify.rewriteLinkStr(href));
    }
  }
  if (content) {
    var $content = $('<div>' + content + '</div>');
    $content.find("a").each(function(){
      _replaceEl($(this));
    });
    return $content.html();
  } else {
    $("a").each(function(){
      _replaceEl($(this));
    });
  }
}
Shopify.rewriteLink();

//nヶ月前後の年月日を取得する
Shopify.getAddMonthDate = function(year,month,day,add){
	var addMonth = month + add;
	var endDate = Shopify.getEndOfMonth(year,addMonth);//add分を加えた月の最終日を取得

	//引数で渡された日付がnヶ月後の最終日より大きければ日付を次月最終日に合わせる
	//5/31→6/30のように応当日が無い場合に必要
	if(day > endDate){
		day = endDate;
	}else{
		//day = day - 1;
	}

	var addMonthDate = new Date(year,addMonth - 1,day);
	return addMonthDate;
}
//今月の月末日を取得
Shopify.getEndOfMonth = function (year,month){
	var endDate = new Date(year,month,0);
	return endDate.getDate();
}
